import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';
import commonStyles from '../../Common/commonStyles';
const styles = StyleSheet.create({
    attachmentText: Object.assign(Object.assign({}, commonStyles.fontS), { fontWeight: 'bold', marginBottom: '2%' }),
    attachmentImage: {
        maxHeight: 275,
        objectFit: 'contain',
        width: '100%',
        border: '1.5px solid #000',
        borderRadius: 4,
        marginBottom: '2%',
        padding: '1%',
    },
});
function SpecificationFiles({ files, t }) {
    return (React.createElement(View, null, files
        .filter((file) => file === null || file === void 0 ? void 0 : file.file)
        .map((file, index) => (React.createElement(View, { key: file === null || file === void 0 ? void 0 : file.id, wrap: false },
        React.createElement(Text, { style: styles.attachmentText }, `${t('attachment')} ${index + 1}`),
        React.createElement(Image, { src: file.file, style: styles.attachmentImage }))))));
}
export default withTranslation()(SpecificationFiles);
